// Generated by purs version 0.15.4
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
var footer = /* #__PURE__ */ Halogen_HTML_Elements.footer_([ /* #__PURE__ */ Halogen_HTML_Core.text("PureScript + Netlify | Source on "), /* #__PURE__ */ Halogen_HTML_Elements.a([ /* #__PURE__ */ Halogen_HTML_Properties.href("https://github.com/nathaniel-may/party-carlo") ])([ /* #__PURE__ */ Halogen_HTML_Core.text("GitHub") ]) ]);
export {
    footer
};
